import React, {useState} from 'react'
import PaiRoutes from "router"
import { Layout } from 'antd'
import { observer } from "mobx-react-lite"
import { Store } from 'utils/mobx'
import { useLocation } from "react-router-dom"
import useRouterChange from "utils/hooks/PaiHooks/useRouterChange"
import PaiPointHeader from "components/PaiPointHeader";
import PaiPointAdminSider from "components/PaiPointAdminSider"
import './PaiPoint.scss'
import PaiPointFooter from "../components/PaiPointFooter";

const { Content } = Layout;

const PaiPoint: React.FC = observer(() => {
    const {RouterStore, MainPageStore, SystemInfoStore} = Store
    const { path } = RouterStore
    const { mainPageConfig } = MainPageStore
    const { userInfo } = SystemInfoStore
    const { businessId= ''} = userInfo
    const { headerConfig, footerConfig } = mainPageConfig
    const location = useLocation();
    const [collapsed, setCollapsed] = useState(false);

    const { isAdminPage } = useRouterChange({
        locationPath: location.pathname,
        path: path,
        businessId: businessId,
    })

    return (
        <div className="pai-point-container">
            <Layout
                className={"pai-point-container-layout"}
            >
                {isAdminPage && <PaiPointAdminSider collapsed={collapsed} />}
                <Layout
                    className={'pai-point-router-container'}
                >
                    <PaiPointHeader />
                    <Content
                        className={'pai-point-content-container'}
                    >
                        <PaiRoutes />
                        <PaiPointFooter />
                    </Content>
                </Layout>
            </Layout>
        </div>
    );
})

export default PaiPoint;
